"use strict";

angular
    .module("imagetrend.components")
    .directive("hlpFormBuilderExamSkillsEdit", [
        function() {
            return {
                restrict: "AE",
                scope: {
                    component: "=?"
                },
                controller: [
                    "$scope",
                    "EXSkill",
                    "EXSkillCategory",
                    function($scope, EXSkill, EXSkillCategory) {
                        $scope.skillsloading = true;
                        $scope.SkillCategoriesFilter = [];
                        $scope.selectedskills = [];
                        $scope.bulkActionItems = [];
                        $scope.showScores = false;
                        $scope.skillDefault = 0;
                        $scope.skills = [];
                        $scope.allSKills = [];

                        $scope.skillsDefaultOptions = [
                            { id: 0, name: "Unselected", is_default: true },
                            { id: 1, name: "Pass" },
                            { id: 2, name: "Fail" }
                        ];

                        if ($scope.allSKills.length == 0) {
                            EXSkill.getActive().then(function(Skills) {
                                if ($scope.component.skill_show_points != null)
                                    $scope.showScores =
                                        $scope.component.skill_show_points;
                                if ($scope.component.skill_default != null)
                                    $scope.skillDefault =
                                        $scope.component.skill_default;
                                for (var x in Skills) {
                                    for (var y in Skills[x].options) {
                                        Skills[x].total_points +=
                                            Skills[x].options[y].points;
                                    }
                                }
                                $scope.skills = angular.copy(Skills);
                                $scope.allSKills = angular.copy(Skills);

                                $scope.updateBothLists();
                                $scope.skillsloading = false;
                            });
                        }

                        $scope.updateBothLists = function() {
                            $scope.selectedskills = [];
                            if ($scope.component.skill_question_ids != null) {
                                $scope.bulkActionItems = $scope.component.skill_question_ids.split(
                                    ","
                                );
                            }

                            $scope.addSelecteSkills();
                            $scope.skillsloading = false;
                        };

                        EXSkillCategory.get().then(function(SkillCategories) {
                            $scope.SkillCategories = SkillCategories;

                            var x, format;
                            for (x in $scope.SkillCategories) {
                                format = {
                                    name: $scope.SkillCategories[x].name,
                                    id: $scope.SkillCategories[x].name
                                };
                                $scope.SkillCategoriesFilter.push(format);
                            }

                            $scope.loading = false;
                        });

                        $scope.skillscolumns = [
                            {
                                label: "Name",
                                field: "name"
                            },
                            {
                                label: "Code",
                                field: "code"
                            },
                            {
                                label: "Critical",
                                field: "critical",
                                type: "yesno"
                            },
                            {
                                label: "Category",
                                field: "exam_skill_category_name"
                            },
                            {
                                label: "Total Points",
                                field: "total_points"
                            },
                            {
                                label: "Last Modified",
                                field: "modifiedon",
                                type: "datetime"
                            }
                        ];

                        $scope.skillfilters = [
                            {
                                name: "Critical",
                                field: "critical",
                                options: [
                                    { name: "Not Critical", id: false },
                                    { name: "Critical", id: true }
                                ]
                            },
                            {
                                name: "Category",
                                field: "exam_skill_category_name",
                                options: $scope.SkillCategoriesFilter
                            }
                        ];

                        $scope.addSelecteSkills = function() {
                            $scope.bulkActionItems.forEach(function(skillid) {
                                $scope.skills.forEach(function(skill) {
                                    if (skill.id == skillid.trim()) {
                                        $scope.selectedskills.push(skill);
                                        $scope.skills.splice(
                                            $scope.skills.indexOf(skill),
                                            1
                                        );
                                    }
                                });
                            });
                            $scope.setSelectedIDs();
                        };

                        $scope.setSelectedIDs = function() {
                            $scope.component.skill_show_points =
                                $scope.showScores;
                            $scope.component.skill_default =
                                $scope.skillDefault;
                            $scope.component.skill_question_ids = null;
                            $scope.selectedskills.forEach(function(skill) {
                                if ($scope.component.skill_question_ids == null)
                                    $scope.component.skill_question_ids =
                                        skill.id;
                                else
                                    $scope.component.skill_question_ids +=
                                        "," + skill.id;
                            });
                            $scope.component.updateSelectedList = true;
                        };

                        $scope.$watch("component.updateEditList", function(
                            newList,
                            oldList
                        ) {
                            if ($scope.component.updateEditList) {
                                $scope.component.updateEditList = false;
                                $scope.component.updateSelectedList = false;
                                $scope.skills = [];

                                $scope.skills = angular.copy($scope.allSKills);
                                $scope.updateBothLists();
                            }
                        });
                    }
                ],
                replace: true,
                transclude: true,
                templateUrl:
                    "templates/form-builder/form-builder-skills-edit/form-builder-skills-edit.html",
                link: function(scope, elem, attrs, ctrl) {}
            };
        }
    ]);
